
<a class="container" href='https://api.whatsapp.com/send?phone=971552784112' target="_blank">
  <img src="./assets/img/whatsappIcon.png" alt='Logo Whatsapp' />
</a>
